import React, { useEffect, useState } from "react";
import { Container, ContainerView } from "../../components/Container";
import { TitleWithBack } from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../contexts";
import Footer from "../../components/Layout/footer";
import {
  AddonAfter,
  AgreeTitle,
  AvailableBalanceTitle,
  ButtonConfirm,
  ButtonMax,
  OptionDurationWraper,
  OrderSummary,
  OrderSummaryLabel,
  OrderSummaryTitle,
  OrderSummaryValue,
  StakeNotify,
  SwiperWraper,
  TitleLablelForm,
} from "./style";
import { NoteIcon } from "../../components/Icons/NoteIcon";
import { FormInputNumber, FormInputNumberRaw } from "../../components/Form";
import {
  calculateVotingPower,
  convertDataRewardPlan,
  convertDecimalToHexBalance,
  convertHexBalanceToDecimal,
  formatMoney,
} from "../../utils/hepler";
import { ModalPasswordRequired } from "../../components/ModalPasswordRequired";

import { TagItem } from "./components/TagItem";
import { Checkbox } from "antd";
import { MyButton, MyCheckBox } from "../../components/Button/style";
import moment from "moment";
import ModalDetail from "./components/ModalDetail";
import Loading from "../../components/loading";
import { ssoGetUserInfo } from "../../services/app";
import produce from "immer";
import { SwiperSlide } from "swiper/react";
import { useWindowSize } from "../../hook/useWindowSize";
export const FORMAT_DATE = "YYYY-MM-DD";

const formatInput = (value) => {
  return value
    ? new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 8,
      }).format(value)
    : "";
};

export const StakeDetail = () => {
  const navigate = useNavigate();
  const { T, masterContract, addressConnected, web3Provider, setAlert } = useApp();
  const [isAgree, setIsAgree] = useState(false);
  const [balanceSGT, setBalanceSGT] = useState();
  const [listRewardPlans, setListRewardPlans] = useState([]);
  const [isOpenModalDetail, setIsOpenModalDetail] = useState(false);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [dataStaking, setDataStaking] = useState({
    amount: null,
  });
  const [showSetPassword, setShowSetPassword] = useState(false);

  const handleSetDataStaking = (key, value) => {
    setDataStaking((prev) => ({ ...prev, [key]: value }));
  };

  const onBack = () => {
    navigate(`/stake`);
  };

  const handleClickMax = () => {
    handleSetDataStaking("amount", balanceSGT);
    if (dataStaking?.plan) {
      handleSetDataStaking(
        "bonus",
        formatMoney(
          calculateVotingPower({
            token: balanceSGT,
            ratio: dataStaking?.plan.ratioGetTokenStaking,
          }),
          0
        )
      );
    }
  };
  const onChangeValue = (val) => {
    setErrors(
      produce((draft) => {
        draft.splice(
          draft.findIndex((item) => item.key === "amount"),
          1
        );
      })
    );
    handleSetDataStaking("amount", val);
    if (dataStaking?.plan) {
      handleSetDataStaking(
        "bonus",
        formatMoney(
          calculateVotingPower({
            token: val,
            ratio: dataStaking?.plan.ratioGetTokenStaking,
          }),
          0
        )
      );
    }
  };

  const handleGetBalanceSGT = async () => {
    const balance = await masterContract.sgtContract.balanceOf(
      addressConnected
    );
    const decimailsSGTContract = await masterContract.sgtContract.decimals();
    setBalanceSGT(convertHexBalanceToDecimal(balance, decimailsSGTContract));
  };

  const handleGetRewardPlans = async () => {
    masterContract.sgtStakingContract.getRewardPlans().then((response) => {
      setListRewardPlans(
        [...response]?.map((item) => convertDataRewardPlan(item))
      );
    });
  };
  const onSetPassword = () => {
    navigate(`/change-password`);
  };
  const handleChangeDuration = (plan) => {
    handleSetDataStaking("plan", plan);
    if (dataStaking?.amount) {
      handleSetDataStaking(
        "bonus",
        formatMoney(
          calculateVotingPower({
            token: dataStaking?.amount,
            ratio: plan.ratioGetTokenStaking,
          }),
          0
        )
      );
    }
  };
  const checkUserHasPassword = async () => {
    try {
      let result = await ssoGetUserInfo();
      if (result?.data?.data?.has_password) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };
  const handleToggleModalDetail = async () => {
    const validatePassword = await checkUserHasPassword();
    if (!validatePassword) {
      setShowSetPassword(true);
      return;
    }
    if (dataStaking?.amount > balanceSGT) {
      setErrors([
        {
          key: "amount",
          value: T("Insufficient balance"),
        },
      ]);
      return;
    }
    try {
      await getEthAccounts();
    } catch (error) {
      setAlert({
        type: "error",
        text: T("please install MetaMask extension."),
      });
      return;
    }
    setErrors([]);
    setIsOpenModalDetail(!isOpenModalDetail);
  };

  const getEthAccounts = async () => {
    try {
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      return accounts;
    } catch (error) {
      throw error;
    }
  }

  const handleStake = async () => {
    try {
      setIsloading(true);
      const gasLimit = 500000;
      const decimailsSGTContract = await masterContract.sgtContract.decimals();
      const addStakingContract = await masterContract?.sgtStakingContract
        ?.address;
      const amountStake = convertDecimalToHexBalance(
        dataStaking?.amount,
        decimailsSGTContract
      );
      await masterContract?.sgtContract
        ?.connect(web3Provider.getSigner())
        ?.approve(addStakingContract, amountStake, { gasLimit });
      const resStake = await masterContract.sgtStakingContract
        ?.connect(web3Provider.getSigner())
        ?.stake(amountStake, dataStaking?.plan?.id, { gasLimit });
      const timeStartStake = new Date().getTime();
      const receipt = await web3Provider.waitForTransaction(resStake.hash);
      setIsloading(false);
      navigate(`/stake-success`, {
        state: {
          ...dataStaking,
          timeStartStake,
        },
      });
    } catch (error) {
      setIsloading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (!masterContract) return;
    handleGetBalanceSGT();
    handleGetRewardPlans();
  }, [masterContract]);

  const size = useWindowSize();
  return (
    <Container>
      {isLoading && <Loading />}
      <div className="w-[95%] max-w-[1270px] mx-auto mt-[16px] lg:mt-[56px] ">
        <TitleWithBack mb={0} title={T("Stake SGT")} onClick={onBack} />
      </div>
      <ContainerView style={{ maxWidth: 768, marginTop: 36 }}>
        <StakeNotify>
          <NoteIcon />
          <div>
            {T(
              "In the staking period, you will receive xSGT as the voting power in the DAO"
            )}
          </div>
        </StakeNotify>
        <div className="mt-[31px]">
          <div>
            <TitleLablelForm>{T("Amount")}</TitleLablelForm>
            <div className="mt-[12px] lg:mt-[14px] ">
              <FormInputNumberRaw
                className="w-full"
                placeholder={T("Please enter the amount")}
                value={dataStaking.amount}
                onChange={onChangeValue}
                step="0.001"
                min={0}
                lang="en-US"
                decimalSeparator={"."}
                formatter={(value) => formatInput(value)}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                addonAfter={"SGT"}
                onAll={handleClickMax}
              />
            </div>
            <div className="flex justify-between items-center mt-2">
              <AvailableBalanceTitle>
                {T("Available Balance")}: {formatMoney(balanceSGT)} SGT
              </AvailableBalanceTitle>
            </div>
          </div>
        </div>
        <div className="mt-[50px] lg:mt-[33px]">
          <TitleLablelForm>{T("Duration")}</TitleLablelForm>
          <OptionDurationWraper className={"showOver"}>
            <SwiperWraper
              className="swiperWraper"
              slidesPerView={size.width < 768 ? 3 : 4}
              spaceBetween={10}
              grabCursor={true}
              pagination={false}
              watchOverflow={true}
            >
              {listRewardPlans.map((planItem, i) => {
                return (
                  <SwiperSlide>
                    <TagItem
                      checked={dataStaking?.plan?.id === planItem.id}
                      key={i}
                      value={planItem.id}
                      label={planItem.year + T(planItem.label)}
                      onChange={(val, checked) =>
                        handleChangeDuration(planItem)
                      }
                    />
                  </SwiperSlide>
                );
              })}
            </SwiperWraper>
          </OptionDurationWraper>
        </div>
        <div className="mt-[25px] lg:mt-[21px]">
          <OrderSummary>
            <OrderSummaryTitle>{T("Order Summary")}</OrderSummaryTitle>
            <div className="flex items-center justify-between mt-[9px]">
              <OrderSummaryLabel>{T("Effective Date")}</OrderSummaryLabel>
              <OrderSummaryValue>
                {moment().format(FORMAT_DATE)}
              </OrderSummaryValue>
            </div>
            <div className="flex items-center justify-between">
              <OrderSummaryLabel>{T("Maturity Date")}</OrderSummaryLabel>
              <OrderSummaryValue>
                {dataStaking?.plan?.year &&
                  moment(
                    new Date().getTime() + dataStaking?.plan?.duration * 1000
                  ).format(FORMAT_DATE)}
              </OrderSummaryValue>
            </div>
            <div className="flex items-center justify-between">
              <OrderSummaryLabel>{T("xSGT Voting Power")}</OrderSummaryLabel>
              <OrderSummaryValue>
                {dataStaking?.amount && dataStaking?.plan && dataStaking?.bonus}
              </OrderSummaryValue>
            </div>
          </OrderSummary>
          <div className="mt-[38px]">
            <span
              style={{
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "15px",
                color: "#F12E11",
              }}
            >
              {T("This function is provided by AI Avatar DAO.")}
            </span>

            {/* <label className="flex items-center gap-[10px] cursor-pointer">
              <Checkbox
                checked={isAgree}
                onChange={(e) => setIsAgree(e.target.checked)}
              />
              <div>
                <AgreeTitle
                  dangerouslySetInnerHTML={{
                    __html: T(
                      "I have read and agree to the AI Avatar Staking Service Agreement."
                    ),
                  }}
                />
              </div>
            </label> */}
          </div>

          {errors?.length > 0 && (
            <div className="mt-4">
              {errors.map((err, i) => (
                <div key={i} className="text-red-500 text-sm">
                  {err.value}
                </div>
              ))}
            </div>
          )}
          <div className="mt-[45px] flex justify-center sm:justify-start">
            <ButtonConfirm
              disabled={!(dataStaking?.plan && !!dataStaking?.amount)}
              className="confirm"
              onClick={handleToggleModalDetail}
            >
              {T("Confirm")}
            </ButtonConfirm>
          </div>
          {isOpenModalDetail && (
            <ModalDetail
              bonus={dataStaking?.bonus}
              duration={
                dataStaking?.plan?.year + " " + T(dataStaking?.plan?.label)
              }
              amount={dataStaking?.amount}
              startDate={moment().format(FORMAT_DATE)}
              endDate={moment(
                new Date().getTime() + dataStaking?.plan?.duration * 1000
              ).format(FORMAT_DATE)}
              onClose={handleToggleModalDetail}
              onSubmit={handleStake}
            />
          )}
        </div>
        {showSetPassword && (
          <ModalPasswordRequired
            onClose={() => setShowSetPassword(false)}
            onSubmit={() => onSetPassword()}
          />
        )}
      </ContainerView>
    </Container>
  );
};
